import { Sku } from "../../../types";
import { buildRetailerPageUrl } from "../../link-builder";
import { Icon } from "../Icon";
import { ProductShippingType } from "./ProductShippingType";
import { RetailerInformation } from "../RetailerInformation";

interface CompareSellersComparison {
  sku: Sku;
}

export const CompareSellersComparison = ({ sku }: CompareSellersComparison) => {
  const {
    images: { urlSmall: imageUrl },
    title,
    titleBeforeTranslation,
    retailerName,
    retailerId,
    premiumSeller,
    storefrontLogo,
  } = sku;

  const price = sku.displayPrice;
  const shippingType =
    sku.shipping.cheapestShippingMethod?.shippingType ?? "STANDARD";
  const shippingPrice =
    sku.shipping.cheapestShippingMethod?.shippingExcludingFeeFormatted;

  return (
    <section class="tw:p-3 tw:bg-fruugo-off-white tw:flex tw:gap-5 tw:flex-col">
      <div class="tw:flex tw:flex-row">
        <img
          src={imageUrl}
          width="86"
          class="tw:w-21.5 tw:h-auto tw:self-start"
          aria-hidden={true}
        />
        <div class="tw:px-3 tw:flex tw:items-center tw:justify-center tw:w-full">
          <h3 class="tw:text-lg tw:font-semibold tw:text-fruugo-black tw:line-clamp-2 tw:m-0">
            {title ?? titleBeforeTranslation}
          </h3>
        </div>
      </div>
      <div>
        <div class="tw:p-4 tw:border-2 tw:border-fruugo-green tw:rounded-lg tw:bg-fruugo-pastel-green tw:relative">
          <span class="tw:absolute tw:right-2 tw:-top-5 tw:p-3 tw:bg-fruugo-green tw:size-10 tw:flex tw:items-center tw:justify-center tw:rounded-lg">
            <Icon name="eye-tracking" className="tw:w-5" fill="#fff" />
          </span>
          <div class="tw:flex tw:items-center tw:mb-4 tw:gap-4">
            <p class="tw:text-xl tw:font-semibold tw:text-fruugo-green tw:mb-0">
              {price}
            </p>
            <ProductShippingType
              shippingType={shippingType}
              shippingPrice={shippingPrice}
            />
          </div>
          <RetailerInformation
            retailerName={retailerName}
            retailerLink={buildRetailerPageUrl(retailerName, retailerId)}
            isPremiumSeller={premiumSeller}
            storefrontLogoUrl={storefrontLogo}
          />
        </div>
      </div>
    </section>
  );
};
